import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatchLocalePipe} from './match-locale.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatchLocalePipe
  ],
  exports: [MatchLocalePipe]
})
export class MatchLocaleModule { }
